import {formsStore} from '../../Form/stores/FormsStore';
import {Filter} from '../../Searches/stores/Filter';
import {executeAdvancedSearch} from '../../Searches/actions/filters';
import {getDefaultOperator} from '../../Searches/consts/operators';
import {toJS} from 'mobx';
import {Search} from '../../Searches/stores/Search';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {serializeQueryValues} from '../../Searches/serializes/searchesList';
import {sendMonitor} from '../../../utils/monitoring';

export function createFilter(field, form) {
    const column = form && form.columnsMap.get(field.toString());
    const search = form?.searches?.formSelected;

    if (!search) {
        form?.searches?.addNewFormSearch();
    }

    const filter = search?.filters?.get(column.name);
    if (!filter) {
        return new Filter(null, {
            column,
            field: column.field,
            operator: getDefaultOperator(column),
            sortIndex: search ? search.filters.size : 1
        });
    } else {
        return new Filter(null, {
            column,
            field: column.field,
            operator: filter.operator,
            value: filter.value,
            values: toJS(filter.values),
            issort: filter.issort,
            isdesc: filter.isdesc,
            sortIndex: filter.sortIndex
        });
    }
}

export function createNewSearchAndExecute(form, filter) {
    const search = form && form.searches && form.searches.formSelected;
    const searchesStore = form && form.searches;
    const newSearch = search.isNew ? search : search.createCopy();

    //in case the search created in versions before 19.0 ingoreCase will be undefiend
    const isIgnore = !!newSearch.ignoreCase;

    newSearch.setIgnoreCase(isIgnore);
    newSearch.setIsNew(true);
    newSearch.setName(getLocalizedText(texts.newSearch));

    if (filter.isEmpty) {
        newSearch.deleteFilter(filter.column.name);
    } else {
        newSearch.setFilter(filter);
    }

    executeAdvancedSearch(newSearch).then(() => {
        const filtersCount =
            searchesStore.formSelected && searchesStore.formSelected.filtersCounter;
        if (filtersCount > 1) {
            sendMonitor('ApplyMultipleFilters', filtersCount);
        }
    });
}

export function setEmptyState(isEmpty) {
    const store = formsStore.currentForm && formsStore.currentForm.searches;

    if (store) {
        store.setEmptyState(isEmpty);
    }
}

export function setF11Search(filters, session, name) {
    let search;
    const form = formsStore.getFormFromSession(session, name);
    const store = form?.searches;

    if (store) {
        if (filters && filters.QueryValues.length) {
            const filtersObj = serializeQueryValues(formsStore.currentForm, filters.QueryValues);
            search = new Search(store, null, filtersObj);
        }
        store.setFormSelected(search);
    }
}

export function changeIgnoreCase(search: Search, filter: Filter) {
    search.setIgnoreCase(!search.ignoreCase);
    filter.setDirty(true);
}
